/**
 * EditorWidget — same content shape as TextWidget (same Lexical
 * EditorState), distinguished only by `contentType: "editor"`. The
 * builder uses this discrimination to render different chrome (toolbar
 * presence, footer buttons) — the materialized output is identical
 * since both feed into duro-lexical-multi's `serializeToHtml`.
 */
import * as Schema from "effect/Schema";

import { LexicalEditorStateJson } from "./lexical-state.js";

export const EditorWidgetContent = Schema.Struct({
  contentType: Schema.Literal("editor"),
  editorState: LexicalEditorStateJson,
});
export type EditorWidgetContent = Schema.Schema.Type<
  typeof EditorWidgetContent
>;
